module.exports = __webpack_public_path__ + "static/img/status_indication03.30ff59a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/aircolor/status_indication03.gif
// module id = IY1B
// module chunks = 1